import React from 'react'
import { When } from 'react-if'
import { LinkButton } from '@/atoms/Button'
import { AsDiv, TitleXS } from '@/atoms/Text'
import { Maybe } from '@/types/codegen-contentful'
import { GuildRolesQuery } from '@/types/codegen-federation'
import { buildAnalyticsLink } from '@/utils/AnalyticsLinkBuilder'
import { useSafeTrack } from '@/utils/analytics'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'

interface FeaturedProjectLearnMoreButtonGroupProps {
  campaign?: Maybe<string>
  href?: Maybe<string>
  guildMemberHref?: Maybe<string>
  data?: GuildRolesQuery
}

export const FeaturedProjectLearnMoreButtonGroup: React.FC<FeaturedProjectLearnMoreButtonGroupProps> = ({
  campaign,
  href,
}) => {
  const { t } = useTranslate('common')
  const track = useSafeTrack()
  const { asPath } = useSafeRouter()
  const analyticsLink = buildAnalyticsLink({
    href: href as string,
    path: asPath,
    campaign: campaign as string,
    linkContext: 'featured-section',
    source: 'featured-section',
  })

  const handleLinkClick = () => {
    track('Featured Project Learn More Link Clicked', { href })
  }

  const showLink = Boolean(analyticsLink)

  return (
    <div className="flex w-full flex-col justify-center gap-4 md:flex-row">
      <When condition={showLink}>
        <LinkButton
          href={analyticsLink}
          className="h-12 w-full min-w-[220px] justify-center space-x-2 md:w-fit"
          onClick={handleLinkClick}
          variant="oxide"
        >
          <TitleXS as={AsDiv}>{t('learnMore', 'Learn More')}</TitleXS>
        </LinkButton>
      </When>
    </div>
  )
}
